import type { ProgramEventContentObjectDetail } from 'models';
import { Avatar, Card, Col, DetailsCategoryItem, Icon, Row } from 'ui';
import { images } from 'common/utils';
import { useGetFirstParentInformation } from './hooks';

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
};

const ProgramEventDetailsCard = ({ eventContentObject }: P) => {
  const { organization } = eventContentObject;
  const { alt, name, profilePhoto } = useGetFirstParentInformation({ eventContentObject });

  return (
    <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <DetailsCategoryItem
            category="organization"
            icon={
              <Avatar
                alt="Organization profile photo"
                fallbackPhoto={images.default.organizationProfilePhoto}
                src={organization.squareLogo ?? organization.profilePhoto}
              />
            }
            name={organization.name}
          />
        </Col>
        <Col span={24}>
          <DetailsCategoryItem
            category="Program"
            icon={<Avatar alt={alt} fallbackPhoto={images.default.programProfilePhoto} src={profilePhoto} />}
            name={name}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default ProgramEventDetailsCard;
